export default __webpack_public_path__ + "static/media/03__o_preview_1.4c038ca0.jpg";